export default __webpack_public_path__ + "static/media/chairside-education.701ccdcc.svg";